import './../../external_lib/d3-color/src/color.js';
import './../../external_lib/d3-color/src/lab.js';
import cubehelix from './../../external_lib/d3-color/src/cubehelix.js';
import '../../../d3-interpolate/dist/d3-interpolate.js';
import { exports as d3InterpolateExports } from '../../../../_virtual/d3-interpolate.js';
var warm = d3InterpolateExports.interpolateCubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
var cool = d3InterpolateExports.interpolateCubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
var c = cubehelix();
function be(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c.h = 360 * t - 100;
  c.s = 1.5 - 1.5 * ts;
  c.l = 0.8 - 0.9 * ts;
  return c + "";
}
export { cool, be as default, warm };
//# sourceMappingURL=rainbow.js.map
